"use strict";
exports.__esModule = true;
//# sourceMappingURL=entity-sales-summary.type.js.map